var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"fab":"","small":"","color":"white"},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"#BDBDBD","dark":""}},[_vm._v("\n\t\t\t\tdelete\n\t\t\t")])],1)]}}])},[_c('span',[_vm._v("מחיקה")])])}
var staticRenderFns = []

export { render, staticRenderFns }